import React, { useEffect } from 'react';
import DatePicker from '../../../DatePicker/DatePicker';
import { formatDateToYYYYMMDD } from '../../utils';
import { TextField } from '@mui/material';
interface InputFieldProps {
  type: 'text' | 'number' | 'date';
  isDecimal?: boolean;
  value: string;
  onBlur: (value: string) => void;
  disabled?: boolean;
  applyExcludeStyle?: boolean;
}
function InputField({
  type,
  value,
  onBlur,
  disabled,
  isDecimal = false,
  applyExcludeStyle,
}: InputFieldProps) {
  const [_value, setValue] = React.useState<string>(value);
  useEffect(() => {
    setValue(value);
  }, [value]);
  const handleChange = (value: string) => {
    if (disabled) return;

    if (type === 'number') {
      const numberPattern = isDecimal ? /^[-]?(?:\d+)?(?:\.\d*)?$/ : /^-?\d+$/;

      if (value !== '' && !numberPattern.test(value.trim())) return;
    }

    const trimmedValue = value.trim();

    setValue(trimmedValue);
  };
  const handleBlur = (value: string) => {
    if (disabled) return;

    const trimmedValue = value.trim();
    setValue(trimmedValue);
    onBlur(trimmedValue);
  };

  return (
    <>
      {type === 'date' ? (
        <DatePicker
          value={_value}
          onChange={(newValue) => {
            if (!newValue) return;
            const formattedDate = formatDateToYYYYMMDD(newValue.toISOString().split('T')[0]);
            onBlur(formattedDate);
          }}
          disabled={disabled}
          applyExcludeStyle={applyExcludeStyle}
        />
      ) : (
        <TextField
          placeholder="Enter value"
          value={_value}
          InputProps={{
            style: {
              height: '25px',
              ...(applyExcludeStyle ? { color: 'orange', textDecoration: 'line-through' } : {}),
            },
          }}
          onChange={(e) => handleChange(e.target.value)}
          onBlur={(e) => handleBlur(e.target.value)}
          disabled={disabled}
          size="small"
          sx={{
            width: '100%',
            '& .MuiInputBase-input': {
              textIndent: '0px',
              paddingX: '0px',
            },
            '& .MuiOutlinedInput-notchedOutline': {
              border: 'none',
            },
            '&:hover .MuiOutlinedInput-notchedOutline': {
              border: 'none',
            },
            '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
              border: 'none',
            },
          }}
        />
      )}
    </>
  );
}

export default InputField;
